import _ from 'lodash';
import React, { useMemo } from 'react';
import { Row } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { Button, Input } from 'reactstrap';
import Entity from './Entity';
import { InputLabel } from './ProofOfDocument';
import User from './User';
import { observer } from 'mobx-react-lite';
import { createWrapperFieldRenderer } from '../../helpers/createWrapperFieldRenderer';
import { buildArrayRowKey } from '../../helpers/buildArrayRowKey';
const BTN = ({
  onClick,
  label,
  disabled
}) => {
  const btnStyle = {
    backgroundColor: '#fff',
    borderRadius: "10px",
    border: "1px solid #1678AE",
    color: '#1678AE',
    whiteSpace: 'normal',
    textAlign: 'left',
    maxWidth: '100%'
  };
  return <div><Button className='mb-3 mt-1' disabled={disabled} style={btnStyle} onClick={onClick}>{label}</Button></div>;
};
const buildLocalId = () => `local_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
const buildMirroredAddressRow = (sourceAddress = {}, type, existingRow = null) => {
  const preservedIdentity = _.pick(existingRow || {}, ['_id', 'aEId', '_isNew']);
  return {
    ...sourceAddress,
    ...preservedIdentity,
    _localId: existingRow?._localId || buildLocalId(),
    type
  };
};
const Page2 = ({
  asLabel,
  data,
  setData,
  editMode = false,
  hasError,
  handleChangeViaObject,
  validationkeyValue,
  setCentralErrors
}) => {
  const renderWrapperField = createWrapperFieldRenderer({
    fieldMap: validationkeyValue,
    dataObj: data,
    disabled: asLabel,
    showError: hasError,
    defaultOnChange: handleChangeViaObject
  });
  const addressListFieldConfigs = useMemo(() => Object.values(validationkeyValue || {}).filter(field => field?.parentField === "addressList[]"), [validationkeyValue]);
  const handlePrincipalAddressWrapperChange = nextData => {
    handleChangeViaObject({
      ...nextData,
      isMailingAddressSame: false,
      isRegisteredAddressSame: false
    });
  };
  const handleAddressListWrapperChange = (type, nextData) => {
    if (type === "REGISTERED") {
      handleChangeViaObject({
        ...nextData,
        isRegisteredAddressSame: false
      });
      return;
    }
    if (type === "MAILING") {
      handleChangeViaObject({
        ...nextData,
        isMailingAddressSame: false
      });
      return;
    }
    handleChangeViaObject(nextData);
  };
  const handleAddressSameChange = type => {
    if (type === "REGISTERED") {
      setData(prev => {
        const currentVal = prev.isRegisteredAddressSame;
        const newVal = !currentVal;
        let newAddressList = prev.addressList ? [...prev.addressList] : [];
        if (newVal && prev.address) {
          const idx = newAddressList.findIndex(item => item.type === "REGISTERED");
          const updatedAddress = buildMirroredAddressRow(prev.address, "REGISTERED", idx > -1 ? newAddressList[idx] : null);
          if (idx > -1) {
            newAddressList[idx] = updatedAddress;
          } else {
            newAddressList.push(updatedAddress);
          }
        }
        return {
          ...prev,
          isRegisteredAddressSame: newVal,
          addressList: newAddressList
        };
      });
    } else if (type === "MAILING") {
      setData(prev => {
        const currentVal = prev.isMailingAddressSame;
        const newVal = !currentVal;
        let newAddressList = prev.addressList ? [...prev.addressList] : [];
        if (newVal && prev.address) {
          const idx = newAddressList.findIndex(item => item.type === "MAILING");
          const updatedAddress = buildMirroredAddressRow(prev.address, "MAILING", idx > -1 ? newAddressList[idx] : null);
          if (idx > -1) {
            newAddressList[idx] = updatedAddress;
          } else {
            newAddressList.push(updatedAddress);
          }
        }
        return {
          ...prev,
          isMailingAddressSame: newVal,
          addressList: newAddressList
        };
      });
    }
  };
  const AddEntity = () => {
    setData(prevItems => {
      const newItems = [...(prevItems?.entities || []), {
        _isNew: true,
        _localId: buildLocalId()
      }];
      return {
        ...prevItems,
        entities: newItems
      };
    });
  };
  const AddUser = () => {
    setData(prevItems => {
      const newItems = [...(prevItems?.individuals || []), {
        isAuthorizedUser: true,
        accessType: "NoGroup",
        isShareHolder: false,
        isIndependentDirector: false,
        _isNew: true,
        _localId: buildLocalId()
      }];
      return {
        ...prevItems,
        individuals: newItems
      };
    });
  };
  const AddShareholder = () => {
    setData(prevItems => {
      const newItems = [...(prevItems?.individuals || []), {
        isShareHolder: true,
        isAuthorizedUser: false,
        isIndependentDirector: false,
        _isNew: true,
        _localId: buildLocalId()
      }];
      return {
        ...prevItems,
        individuals: newItems
      };
    });
  };
  const AddIndependentDirector = () => {
    setData(prevItems => {
      const newItems = [...(prevItems?.individuals || []), {
        isShareHolder: false,
        isAuthorizedUser: false,
        isIndependentDirector: true,
        _isNew: true,
        _localId: buildLocalId()
      }];
      return {
        ...prevItems,
        individuals: newItems
      };
    });
  };
  const removeEntitiy = index => {
    setData(prevItems => {
      const newItems = [...(prevItems?.entities || [])];
      newItems.splice(index, 1);
      return {
        ...prevItems,
        entities: newItems
      };
    });
  };
  const removeUser = index => {
    setData(prevItems => {
      const newItems = [...(prevItems?.individuals || [])];
      newItems.splice(index, 1);
      return {
        ...prevItems,
        individuals: newItems
      };
    });
  };
  const AddAddress = () => {
    setData(prevItems => {
      const newItems = [...(prevItems?.addressList || []), {
        _isNew: true,
        _localId: buildLocalId()
      }];
      return {
        ...prevItems,
        addressList: newItems
      };
    });
  };
  const removeAddress = index => {
    setData(prevItems => {
      const newItems = [...(prevItems?.addressList || [])];
      newItems.splice(index, 1);
      return {
        ...prevItems,
        addressList: newItems
      };
    });
  };
  return <div>
            <p className='bold-text pt-2'>In order to apply for Plus account, we will need to review some prequalifications. Please answer the following questions:</p>

            <h1 className='pt-3'>General Business Information</h1>
            <Row>
                {renderWrapperField('Business_Name')}
            </Row>
            <Row>
                {renderWrapperField('Doing_Business_As')}
            </Row>

            <InputLabel required label={"Address of Principal Place of Business (e.g. operating address)"} labelStyle={{
      fontSize: 15
    }} />
            <p className='ps-1 mb-0' style={{
      fontSize: 11,
      fontStyle: 'italic'
    }}>This is the address you operate your business at, not a registered address. Please do not enter P.O. Boxes, they will not be accepted.</p>

            <Row>
                {renderWrapperField('address.street', {
        onChange: handlePrincipalAddressWrapperChange
      })}

            </Row>
            <Row>
                {renderWrapperField('address.buildingNumber', {
        onChange: handlePrincipalAddressWrapperChange
      })}
            </Row>
            <Row className='mb-3'>
                {renderWrapperField('address.city', {
        className: "col-sm-6 col-md-3",
        onChange: handlePrincipalAddressWrapperChange
      })}
                {renderWrapperField('address.state', {
        className: "col-sm-6 col-md-3",
        onChange: handlePrincipalAddressWrapperChange
      })}

                {renderWrapperField('address.pinCode', {
        className: "col-sm-6 col-md-3",
        onChange: handlePrincipalAddressWrapperChange
      })}

                {renderWrapperField('address.country', {
        className: "col-sm-6 col-md-3 mt-3",
        onChange: handlePrincipalAddressWrapperChange
      })}
            </Row>





            {data?.addressList?.map((address, index) => {
      const addressType = {
        "REGISTERED": "Registered Address of Business",
        "MAILING": "Mailing Address of Business"
      };
      const borderBottom = {
        borderBottom: "1px solid #ddd"
      };
      const checkboxId = `mailingCheckbox-${address?.type}-${index}`;
      return <div style={index === data?.addressList?.length - 1 ? borderBottom : {}} className='address-box-tab position-relative' key={buildArrayRowKey(address, index, 'addressList')}>
                    <div className='d-flex align-items-center justify-content-between' style={{
          margin: "0px 0px 5px 5px"
        }}>

                        <span style={{
            fontSize: 16,
            fontWeight: "500",
            display: "block"
          }}>
                            {addressType?.[address?.type] ?? ""}
                            <font color="red">*</font>
                        </span>


                        <div className="mb-0 ms-1 d-flex align-items-center">
                            <Input type="checkbox" id={checkboxId} data-testid={checkboxId} checked={address?.type === "MAILING" ? data?.isMailingAddressSame : data?.isRegisteredAddressSame} onChange={() => handleAddressSameChange(address?.type)} disabled={asLabel} />
                            <label htmlFor={checkboxId} className="ps-2 mt-2">
                                Same as the principal place of business
                            </label>
                        </div>
                    </div>


                    <Row>
                        {renderWrapperField('addressList[].street', {
            key: `addressList[].street-${address?._localId || index}`,
            arrayIndexing: index,
            haveDependentSubFields: true,
            customProp: addressListFieldConfigs,
            onChange: nextData => handleAddressListWrapperChange(address?.type, nextData)
          })}
                    </Row>
                    <Row>
                        {renderWrapperField('addressList[].buildingNumber', {
            key: `addressList[].buildingNumber-${address?._localId || index}`,
            arrayIndexing: index,
            onChange: nextData => handleAddressListWrapperChange(address?.type, nextData)
          })}
                    </Row>
                    <Row>
                        {renderWrapperField('addressList[].city', {
            key: `addressList[].city-${address?._localId || index}`,
            arrayIndexing: index,
            className: "col-sm-6 col-md-3",
            onChange: nextData => handleAddressListWrapperChange(address?.type, nextData)
          })}
                        {renderWrapperField('addressList[].state', {
            key: `addressList[].state-${address?._localId || index}`,
            arrayIndexing: index,
            className: "col-sm-6 col-md-3",
            onChange: nextData => handleAddressListWrapperChange(address?.type, nextData)
          })}

                        {renderWrapperField('addressList[].pinCode', {
            key: `addressList[].pinCode-${address?._localId || index}`,
            arrayIndexing: index,
            className: "col-sm-6 col-md-3",
            onChange: nextData => handleAddressListWrapperChange(address?.type, nextData)
          })}

                        {renderWrapperField('addressList[].country', {
            key: `addressList[].country-${address?._localId || index}`,
            arrayIndexing: index,
            className: "col-sm-6 col-md-3 mt-3",
            onChange: nextData => handleAddressListWrapperChange(address?.type, nextData)
          })}
                    </Row>
                </div>;
    })}



            {renderWrapperField('Business_Registration_Country')}

            {renderWrapperField('EIN')}

            {renderWrapperField('Business_Tax_ID')}

            {renderWrapperField('mobilePhone', {
      className: 'my-2',
      onError: v => {
        setCentralErrors(prevErrors => ({
          ...prevErrors,
          mobilePhone: v
        }));
      }
    })}

            <div className='mt-4'>
                {renderWrapperField('landlinePhone', {
        onError: v => {
          setCentralErrors(prevErrors => ({
            ...prevErrors,
            landlinePhone: v
          }));
        }
      })}
            </div>



            <div className='ms-1'>
                {renderWrapperField('entityType')}
            </div>


            {renderWrapperField('Business_Registration_Number', {
      className: "col-sm-6"
    })}
            {renderWrapperField('Business_Formation_Date', {
      className: "col-sm-6"
    })}



            {renderWrapperField('inOperation')}



            {renderWrapperField('operationStartDate', {
      className: "col-sm-6"
    })}
            {renderWrapperField('operateEstDate', {
      className: "col-sm-6"
    })}



            {renderWrapperField('Business_Industry_Type')}

            {renderWrapperField('website')}




            {renderWrapperField('url')}

            {renderWrapperField('engage')}

            {renderWrapperField('empCount')}


            {/* ================================================================== */}

            <div>
                {renderWrapperField('Bank_Account_Another_Financial_Institution')}
                {renderWrapperField('additionalBankAccountInstName')}
            </div>

            <div>
                {renderWrapperField('penalty')}
                {renderWrapperField('penaltyDetails')}
            </div>

            <div>
                {renderWrapperField('litigation')}
                {renderWrapperField('litigationDetails')}
            </div>

            <div>
                {renderWrapperField('BUS_Source_Of_Funds', {
        className: "my-3"
      })}

            </div>

            <div>
                {renderWrapperField('liquidFunds')}

                {renderWrapperField('hasEntity')}
            </div>

            {/* ======================= entities ======================= */}
            {data?.hasEntity ? (data?.entities ?? [{}])?.map((_, i) => {
      return <div className='box-tab' key={buildArrayRowKey(data?.entities?.[i], i, 'entity')}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <div style={{
            fontWeight: 'bold',
            fontSize: 18
          }}>Entity {i + 1}</div>
                                <div className='me-2' onClick={() => removeEntitiy(i)}>
                                    {data?.entities?.length > 1 && !asLabel && <FaTimes size={22} color='red' />}
                                </div>
                            </div>
                            <Entity index={i} asLabel={asLabel} data={data} handleChangeViaObject={handleChangeViaObject} hasError={hasError} validationkeyValue={validationkeyValue} />
                        </div>;
    }) : <></>}
            {asLabel || !data?.hasEntity ? null : <BTN onClick={AddEntity} label="Add Entity" />}

            {/* ======================= Users ======================= */}
            <div>
                <h2>Officers or Authorized Account Users</h2>
                In this section, list all directors and officers in your organization. Officers include Chief Executive Officer, Chief Financial Officer, Chief Operating Officer, Director or other persons that exert control over the business. You may also list persons who are not controllers but whom you request have informational access to your account for operational purposes.
                <h2 className='mt-4'>Enter User information, click Add User below to add more users</h2>
            </div>
            {(data?.individuals ?? [{}])?.map((_, i) => {
      const individual = data?.individuals?.[i];
      return <div className='box-tab' key={buildArrayRowKey(data?.individuals?.[i], i, 'individual')}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <div style={{
            fontWeight: 'bold',
            fontSize: 18
          }}>{individual?.isPrimaryUser ? `Primary User` : ` User ${i + 1}`}
                                </div>
                                <div className='me-2' onClick={() => removeUser(i)}>
                                    {data?.individuals?.length > 1 && !asLabel && !editMode && i != 0 && <FaTimes size={22} color='red' />}
                                </div>
                            </div>
                            <User index={i} asLabel={asLabel} data={data} hasError={hasError} validationkeyValue={validationkeyValue} handleChangeViaObject={handleChangeViaObject} setCentralErrors={setCentralErrors} />
                        </div>;
    })}
            {asLabel || editMode ? null : <div className='d-flex flex-wrap gap-2'>
                    <BTN onClick={AddUser} label="Add Officer/Authorized User" disabled={data?.individuals?.filter(ind => ind?.isAuthorizedUser)?.length >= 11} />
                    <BTN onClick={AddShareholder} label="Add Beneficial Owner/Shareholder" />
                    <BTN onClick={AddIndependentDirector} label="Add Director/Manager" />
                </div>}


            {/* ======================= shareholder  =======================*/}
            {/* <div>
                <h2>Shareholders</h2>
                <h2 className='mt-4'>Enter each individual shareholder controlling 10% or more of the entity.</h2>
             </div>
             {
                (data?.individuals ?? [{}])?.map((_, i) => {
                    return (
                        <div className='box-tab' key={i}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <div style={{ fontWeight: 'bold', fontSize: 18 }}>Individual Shareholder {i + 1}</div>
                                <div className='me-2' onClick={() => removeShareholder(i)}>
                                    {(data?.individuals?.length > 1 && !asLabel) && <FaTimes size={22} color='red' />}
                                </div>
                            </div>
                            <Shareholder
                                index={i}
                                asLabel={asLabel}
                                data={data}
                                handleChange={handleChange}
                                hasError={hasError}
                                handleValidation={handleValidation}
                                validationkeyValue={validationkeyValue}
                             />
                        </div>
                    )
                })
             }
             {asLabel ? null : <BTN onClick={AddShareholder} label="Add Individual Shareholder" />} */}

        </div>;
};
export default observer(Page2);
